export enum AppStatusEnum {
  EDITING = 'Editing',
  SUBMITTED_TO_A0 = 'SubmittedToAO',
  FOLLOW_UP_REQUIRED = 'FollowUpRequired',
  REJECTED = 'Rejected',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}

export enum ApprovalStatusEnum {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  FOLLOW_UP_REQUIRED = 'FollowUpRequired',
}

export enum PdfFileTypeEnum {
  UploadedFile = 'uploaded_file',
  ApplicationForAppointment = 'application_for_appointment',
  AgencyAgreementPHKL = 'agency_agreement_phkl',
  AgencyAgreementPGHK = 'agency_agreement_pghk',
  AcknowledgmentInMainlandChina = 'acknowledgment_in_mainland_china',
  SupplementaryAgreementForManagers = 'supplementary_agreement_for_managers',
  AcademicQualification = 'authorization_for_reference_checking_on_academic_qualification',
  FinancingAgreement = 'financing_agreement',
  ManagerLiabilities = 'manager_liabilities',
}

export type RecruiterInfoItem = {
  recruiterCode: string;
  recruiterName: string;
  recruiterDetails: string;
  recruiterBusinessAddress: string;
  recruiterDSGNCode: string;
}

export type PersonalParticularInfoItem = {
  engSurname: string;
  engFirstName: string;
}

export type AssignDesignationInfoItem = {
  araAgentCode: string;
  araAgentName: string;
  potentialRecruiterName: string;
  potentialRecruiterHKID: string;
  designationRecommendCode: string;
}

export type SupplementaryInfoItem = {
  reason: string;
}

export type GpsLocationItem = {
  latitude: number;
  longitude: number;
}

export type FollowUpDetailsItem = {
  isFollowUpByZone: boolean;
  remarksFromAMD: string;
  remarksFromCaseOfficer: string;
}

export type AMDApprovalActionItem = {
  isApprovalRequired: boolean;
}

export type PersonalParticularItem = {
  _id: string;
  appId: string;
  recruiterInfo: RecruiterInfoItem;
  personalParticular: PersonalParticularInfoItem;
  appStatus: string;
  submittedDate: Date;
  lastUpdatedDate: Date;
  assignDesignation: AssignDesignationInfoItem;
  supplementary: SupplementaryInfoItem;
  gpsLocation: GpsLocationItem;
  followUpDetails: FollowUpDetailsItem;
  amdApprovalAction: AMDApprovalActionItem;

  // FOLLOW UP
  // lastUpdateUser: string;
}

export type PersonalParticularDocItem = {
  fileBase64Str: string
}

//PHKL Custom -s
export enum ChangeRequestSectionEnum {
  MOBILE = 'mobilePhone',
  EMAIL = 'email',
  DESIGNATION = 'designation',
  FINANCING_PACKAGE = 'financingPackage',
}

export interface ChangeRequestItem {
  section: string;
  submittedDate: Date;
  modification: {
    email?: string;
    mobilePhone?: string;
    isVerified?: boolean;
    designation?: string;
    recommendReason?: string;
    finScheme?: string;
    finCategory?: string;
    finApplyMonthly?: string;
  };
  sessionId: string;
}

export interface ChangeRequestHistoryItem {
  section: ChangeRequestSectionEnum;
  submittedDate?: Date;
  actionDate?: Date;
  action?: 'approved' | 'rejected';
  previousValue?: {
    mobilePhone?: string;
    email?: string;
    designation?: string;
    recommendReason?: string;
    finCategory?: string;
    finScheme?: string;
    finApplyMonthly?: number;
  };
  newValue?: {
    mobilePhone?: string;
    email?: string;
    designation?: string;
    recommendReason?: string;
    finCategory?: string;
    finScheme?: string;
    finApplyMonthly?: number;
  };
}

export interface ChangeRequestItem {
  section: string;
  submittedDate: Date;
  modification: {
    email?: string;
    mobilePhone?: string;
    isVerified?: boolean;
    designation?: string;
    recommendReason?: string;
    finScheme?: string;
    finCategory?: string;
    finApplyMonthly?: string;
  };
  sessionId: string;
}

export interface ChangeRequestData {
  mobile?: ChangeRequestItem;
  email?: ChangeRequestItem;
  designation?: ChangeRequestItem;
  financingPackage?: ChangeRequestItem;
}

export interface UploadSignedDocFileInfo {
  fileType: PdfFileTypeEnum.FinancingAgreement | PdfFileTypeEnum.ManagerLiabilities;
  fileName?: string;
  fileSize?: number;
}

export interface UploadSignedDocAgentInfo {
  agentCode: string;
  agentName: string;
  title: string;
  status: string;
  email: string;
}

export type UploadSignedDocData = {
  financingAgreement?: UploadSignedDocFileInfo;
  managerLiabilities?: UploadSignedDocFileInfo;
  agentList?: UploadSignedDocAgentInfo[];
};
//PHKL Custom -e
